window.updateFreeShippingMessage = function () {
  const messageContainer = document.getElementById('free-shipping-message');
  console.log("inside updateFreeShippingMessage: "+messageContainer);
  if (!messageContainer) return;

  const freeShippingThreshold = 2500;
  // We need to fetch the cart total from the API to ensure it's up-to-date
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartTotal = cart.total_price;

      if (cartTotal < freeShippingThreshold) {
        const remaining = ((freeShippingThreshold - cartTotal) / 100).toFixed(2);
        messageContainer.textContent = `Nur noch €${remaining} bis zum kostenlosen Versand!`;
        messageContainer.classList.remove('success');
      } else {
        messageContainer.textContent = `🎉 Glückwunsch! Dein kostenloser Versand ist gesichert.`;
        messageContainer.classList.add('success');
      }

      // Add the 'show' class to make the message visible
      messageContainer.classList.add('show');
      
      // Set a timer to hide the message after 5 seconds
      setTimeout(function () {
        messageContainer.classList.remove('show');
      }, 5000);
    })
    .catch(e => console.error(e));
};